import PythonApi from '@/services/PythonApi';

export default {
  uploadCows(cows) {
    return PythonApi().post("cows/upload", cows)
  },
  latestAccData(cowID, fromDate, toDate) {
    const params = new URLSearchParams();

    if(fromDate)
      params.append('from_date', fromDate);
    if (toDate)
      params.append('to_date', toDate);
    
    params.append('chart_type', 'acc');

    return PythonApi().get(`sensorLog/get-chart-data/${cowID}`, params);
  },
  latestTempData(cowID, fromDate, toDate) {
    const params = new URLSearchParams();

    if(fromDate)
      params.append('from_date', fromDate);
    if (toDate)
      params.append('to_date', toDate);

    params.append('chart_type', 'temp');

    return PythonApi().get(`sensorLog/get-chart-data/${cowID}`, params);
  },
  latestPhData(cowID, fromDate, toDate) {
    const params = new URLSearchParams();

    if(fromDate)
      params.append('from_date', fromDate);
    if (toDate)
      params.append('to_date', toDate);

    params.append('chart_type', 'ph');

    return PythonApi().get(`sensorLog/get-chart-data/${cowID}`, params);
  },
  // should return a single number that is the avg of the last 48 hours of movement data
  getRelativeAccData(cowID, fromDate, toDate) {
    const params = new URLSearchParams();

    if(fromDate)
      params.append('from_date', fromDate);
    if (toDate)
      params.append('to_date', toDate);

    params.append('chart_type', 'rel_acc');

    return PythonApi().get(`sensorLog/get-chart-data/${cowID}`, params);
  },
  getActivityMedian(cowID, payload) {
    const params = new URLSearchParams();
    Object.keys(payload).forEach((key) => {
      if (payload[key])
        params.append(key, payload[key])
    })
    return PythonApi().get(`alerts/activity_median/${cowID}`, params);
  }
};



// WEBPACK FOOTER //
// ./src/services/CowsService.js